/**
 * Utility functions for handling image URLs in the provider dashboard
 */

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '/api').replace(/\/$/, '');
const STORED_IMAGE_NAME = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

/**
 * Provider images are persisted as storage object names. Turn those names into
 * browser URLs for dashboard previews while leaving legacy absolute URLs intact.
 *
 * @param {string} url - A stored object name or legacy absolute image URL
 * @returns {string} - A browser-fetchable image URL
 */
export const normalizeImageUrl = (url) => {
  if (!url) return url;
  if (STORED_IMAGE_NAME.test(url)) {
    return `${API_BASE_URL}/images/large/${url}`;
  }
  return url;
};

/** Resolve a provider video storage name through the existing video endpoint. */
export const normalizeVideoUrl = (url) => {
  if (!url) return url;
  if (STORED_IMAGE_NAME.test(url)) {
    return `${API_BASE_URL}/videos/${url}`;
  }
  return url;
};

const imageUtils = {
  normalizeImageUrl,
  normalizeVideoUrl,
};

export default imageUtils;
